import React from 'react'

import './Canvas.scss';

function Canvas({opaque, isOpen, canvasScale, setCanvasScale}) {
  const video = React.useRef( null )
  const canvas = React.useRef( null )

  // const [ canvasScale, setCanvasScale ] = React.useState( {
  //   scaleX: window.innerWidth / 640,
  //   scaleY: window.innerHeight / 480,
  // } )

  React.useEffect( () => {
    navigator.mediaDevices.getUserMedia( { audio: false, video: true } )
      .then( stream => {
        ('srcObject' in video.current)
          ? video.current.srcObject = stream
          : video.current.src = URL.createObjectURL( stream );
        video.current.play();
      } )
      .catch( error => {
        window.console && console.error(error)

      } )
  }, [] )


  const onCanPlay = () => {
    // const canvasContext = canvas.current.getContext(`2d`, { alpha: false } )
    const canvasContext = canvas.current.getContext(`2d` )


    const computeFrame = () => {
      // canvasContext.filter = 'blur(10px) brightness(65%) hue-rotate(225deg) saturate(751%) contrast(239%)';
      // canvasContext.filter = 'blur(4px)';
      canvasContext.drawImage( video.current, 0,0, video.current.videoWidth, video.current.videoHeight )

      let frameData = canvasContext.getImageData( 0,0, video.current.videoWidth, video.current.videoHeight )
      let length = frameData.data.length

      for (var i = 0; i < length; i += 4) {
          var r = frameData.data[i];
          var g = frameData.data[i+1];
          var b = frameData.data[i+2];
          var v = (0.2126*r + 0.7152*g + 0.0722*b <= 70) ? 255 : 0;
          frameData.data[i] = frameData.data[i+1] = frameData.data[i+2] = v
      } 

      for (var i = 0; i < length; i += 4) {
        if(frameData.data[i] + frameData.data[i + 1] + frameData.data[i + 2] < 10){ 
            frameData.data[i + 3] = 0;
        }
      } 

      canvasContext.putImageData(frameData, 0, 0); 
    }
  
    const videoTransfer = () => {
      computeFrame()
      window.requestAnimationFrame(videoTransfer);
    }
  
    const canvasSetup = () => {
      canvas.current.width = video.current.videoWidth
      canvas.current.height = video.current.videoHeight
      // canvas.current.width = window.innerWidth
      // canvas.current.height = window.innerHeight
      
      videoTransfer()
    }
    
    canvasSetup();
  }
  

  return (
    <div className={ [ `mirror`, `mirror--${ opaque ? 'is-opaque' : 'not-opaque' }` ].join( ` ` ) } >
      {/* <div className={ [ `mirror-effect` ] } /> */}

      <canvas
        // style={{ transform: `translate3D( -${ 640 }px, 0, 0 ) scale3D(-${ canvasScale.scaleX }, ${ canvasScale.scaleY }, 1)` }}
        className={ `mirror-canvas` }
        ref={ canvas } />

      <video 
          onCanPlay={ onCanPlay }
          className={ `mirror-video` }
          ref={ video } />
    </div>
  );
}

export default Canvas;
